<template>
  <div class="login-view">
    <section class="login-brand-panel" aria-hidden="true">
      <div class="login-brand-panel__content">
        <img
          src="../assets/figma/logo-login-page.svg"
          alt="E-Inspektor"
          class="login-brand-panel__logo"
        />
      </div>
    </section>

    <section class="login-form-panel">
      <div class="login-form-card">
        <h1 class="login-form-card__title">{{ $t('AUTHENTICATION.BUTTONS.LBL_SIGN_IN') }}</h1>

        <form name="form" class="login-form" @submit.prevent="handleLogin">
          <div class="form-group login-form-group">
            <label for="email" class="login-label">{{ $t('AUTHENTICATION.FIELDS.LBL_EMAIL') }}</label>
            <input
              id="email"
              v-model="user.username"
              v-validate="'required'"
              type="text"
              class="form-control login-input"
              name="email"
              autocomplete="username"
            />
            <div
              v-if="errors.has('email')"
              class="alert alert-danger login-alert"
              role="alert"
            >
              {{ $t('AUTHENTICATION.FIELDS.LBL_EMAIL') }}
              {{ $t('SHARED.VALIDATION.LBL_REQUIRED_FIELD') }}
            </div>
          </div>

          <div class="form-group login-form-group">
            <label for="password" class="login-label">{{ $t('AUTHENTICATION.FIELDS.LBL_PASSWORD') }}</label>
            <input
              id="password"
              v-model="user.password"
              v-validate="'required'"
              type="password"
              class="form-control login-input"
              name="password"
              autocomplete="current-password"
            />
            <div
              v-if="errors.has('password')"
              class="alert alert-danger login-alert"
              role="alert"
            >
              {{ $t('AUTHENTICATION.FIELDS.LBL_PASSWORD') }}
              {{ $t('SHARED.VALIDATION.LBL_REQUIRED_FIELD') }}
            </div>
          </div>

          <div class="form-group login-form-group login-form-group--submit">
            <button class="btn btn-primary login-submit" :disabled="loading">
              <span v-show="loading" class="spinner-border spinner-border-sm"></span>
              <span>{{ $t('AUTHENTICATION.BUTTONS.LBL_SIGN_IN') }}</span>
            </button>
          </div>

          <div class="form-group login-form-group" v-if="message">
            <div class="alert alert-danger login-alert" role="alert">{{ message }}</div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: ''
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then(
            () => {
              this.$router.push('/');
            },
            error => {
              this.loading = false;

              if (!error.response) {
                this.message = this.$t('SHARED.LBL_GENERAL_ERROR');
              } else {
                switch (error.response.status) {
                  case 401:
                    this.message = this.$t('MENU.LBL_WRONG_PASSWORD_OR_USER_NOT_FOUND');
                    break;
                  case 403:
                    this.message = this.$t('AUTHENTICATION.LBL_DEACTIVATED_ACCOUNT');
                    break;
                  default:
                    this.message = this.$t('SHARED.LBL_GENERAL_ERROR');
                    break;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.login-view {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(360px, 54.5%) minmax(360px, 45.5%);
  background: #ffffff;
}

.login-brand-panel {
  position: relative;
  overflow: hidden;
  background: linear-gradient(124deg, #9f348f 0%, #3a3b90 42%, #193c86 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 42px 32px;
}

.login-brand-panel::before {
  content: '';
  position: absolute;
  top: -180px;
  left: -200px;
  width: 460px;
  height: 460px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  filter: blur(1px);
}

.login-brand-panel::after {
  content: '';
  position: absolute;
  right: -220px;
  bottom: -220px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.login-brand-panel__content {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-brand-panel__logo {
  width: min(86%, 640px);
  height: auto;
}

.login-form-panel {
  background: #f5f7fb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 32px;
}

.login-form-card {
  width: 100%;
  max-width: 430px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 24px 54px rgba(17, 52, 111, 0.16);
  padding: 34px 30px 28px;
}

.login-form-card__title {
  margin: 0 0 22px;
  font-size: 1.65rem;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #11346f;
  text-align: left;
}

.login-form-group {
  margin-bottom: 14px;
}

.login-form-group--submit {
  padding-top: 8px;
}

.login-label {
  display: block;
  margin: 0 0 7px;
  font-size: 0.9rem;
  line-height: 1.3;
  font-weight: 600;
  color: #334155;
}

.login-input {
  min-height: 46px;
  border-radius: 12px;
  border: 1px solid #c9d4e4;
  box-shadow: none;
  color: #0f172a;
  padding: 10px 14px;
}

.login-input:focus {
  border-color: #1b4f9c;
  box-shadow: 0 0 0 3px rgba(27, 79, 156, 0.16);
}

.login-submit {
  width: 100%;
  min-height: 46px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(90deg, #9f348f 0%, #183f86 100%);
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.login-submit:hover,
.login-submit:focus {
  background: linear-gradient(90deg, #8f2d82 0%, #16397a 100%);
}

.login-submit:disabled {
  opacity: 0.72;
}

.login-alert {
  margin: 8px 0 0;
  font-size: 0.84rem;
  border-radius: 10px;
  padding: 8px 10px;
}

@media (max-width: 1200px) {
  .login-view {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .login-brand-panel {
    min-height: 300px;
    padding: 40px 22px;
  }

  .login-brand-panel__logo {
    width: min(88%, 520px);
  }

  .login-form-panel {
    padding: 34px 18px 42px;
  }

  .login-form-card {
    max-width: 560px;
  }
}

@media (max-width: 640px) {
  .login-brand-panel {
    min-height: 220px;
    padding: 26px 16px;
  }

  .login-brand-panel__logo {
    width: min(92%, 400px);
  }

  .login-form-panel {
    padding: 24px 14px 34px;
  }

  .login-form-card {
    border-radius: 18px;
    padding: 24px 16px 18px;
  }

  .login-form-card__title {
    font-size: 1.35rem;
  }
}
</style>
